import { useEffect } from 'react';

import { APP_NAME } from '../config';
import { capitalize } from '../utils';
function useDocumentTitle(title, prevailOnUnmount = false) {
  const defaultTitle = capitalize(APP_NAME) + ' Dashboard';

  useEffect(() => {
    document.title = `${defaultTitle} | ${title}`;
  }, [title]);

  useEffect(
    () => () => {
      if (!prevailOnUnmount) {
        document.title = defaultTitle;
      }
    },
    []
  );
}

export { useDocumentTitle };
